import { IconProps } from './types';
const TargetBarIcon: React.FC<IconProps> = (props: IconProps) => {
  const { width = 9, height = 34, fillColor = 'var(--yellow-dark-3)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 9 34"
      fill="none"
    >
      <path d="M4.33013 7.5L0 0H8.66026L4.33013 7.5Z" fill={fillColor} />
      <path
        d="M3.33013 5.5C3.33013 4.94772 3.77784 4.5 4.33013 4.5C4.88241 4.5 5.33013 4.94772 5.33013 5.5V32.5C5.33013 33.0523 4.88241 33.5 4.33013 33.5C3.77784 33.5 3.33013 33.0523 3.33013 32.5V5.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default TargetBarIcon;
